import qs from "qs";
const getQueryParam = (key)=>{
    if ("u" < typeof window) return '';
    const search = window.location.search.substring(1);
    if (!search.length) return null;
    return qs.parse(search)[key];
};
const src_getQueryParam = getQueryParam;
export default src_getQueryParam;
